import { render } from "./Data.vue?vue&type=template&id=15a9fb46"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Code/vdata/vdata-vuejs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__